import { apiFetch } from "./api";
import { generateThumbnail } from "./thumbnail";

// ============================================================================
// DTOs (mirror src/Allmark.Contracts/Quotes/QuoteFileDto.cs)
// ============================================================================

export interface QuoteFile {
  quoteFileId: number;
  originalFileName: string;
  contentType: string;
  sizeBytes: number;
  uploadedAtUtc: string;
  uploadedByName: string;
  hasThumbnail: boolean;
  /** Hex-encoded row version; treat as opaque — used as ETag in If-Match header. */
  rowVersion: string;
}

export interface UploadQuoteFileResponse {
  file: QuoteFile;
}

export const quoteFilesApi = {
  upload: async (quoteId: number, file: File): Promise<UploadQuoteFileResponse> => {
    const fd = new FormData();
    fd.append("file", file, file.name);
    // Best-effort: null (unsupported type or any failure) simply means no thumbnail part.
    const thumb = await generateThumbnail(file);
    if (thumb) fd.append("thumbnail", thumb, "thumbnail.webp");
    return apiFetch<UploadQuoteFileResponse>(`/api/quotes/${quoteId}/files`, {
      method: "POST",
      body: fd,
    });
  },

  list: (quoteId: number): Promise<QuoteFile[]> =>
    apiFetch<QuoteFile[]>(`/api/quotes/${quoteId}/files`),

  /** Returns a URL string suitable for direct anchor href — does not fetch. */
  downloadUrl: (quoteId: number, fileId: number): string =>
    `/api/quotes/${quoteId}/files/${fileId}`,

  /** Returns the thumbnail URL for a quote file — does not fetch. */
  thumbnailUrl: (quoteId: number, fileId: number): string =>
    `/api/quotes/${quoteId}/files/${fileId}/thumbnail`,

  delete: (quoteId: number, fileId: number, rowVersionHex: string): Promise<void> =>
    apiFetch<void>(`/api/quotes/${quoteId}/files/${fileId}`, {
      method: "DELETE",
      headers: { "If-Match": `"${rowVersionHex}"` },
    }),
};
